import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import MaskedInput from 'react-text-mask';
import { SovosTextField, SovosRaisedButton } from 's1-ui';
import XIcon from 'commonComponents/xIcon';

const styles = {
  lineContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  buttonText: {
    fontWeight: 300
  },
  textField: {
    paddingRight: 15,
  },
  underline: {
    '&:not(.bullshit):not(.classes):not(.ftw):after': {
      borderBottom: '2px solid black'
    },
    '&:hover:not(.just):not(.trying):not(.to):not(.win)': {
      '&:before, &:after': { borderBottom: '2px solid black' },
    }
  }
};

function AccountMask(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      { ...other }
      ref={ ref => inputRef(ref ? ref.inputElement : null) }
      mask={ [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/] }
      placeholderChar="_"
    />
  );
}

export const UnstyledCarrierAccountsForm = ({
  newLicenseNumber, onChange, cancel, onSubmit, classes
}) => (
  <div className={ classes.lineContainer }>
    <SovosTextField
      InputProps={ {
        inputComponent: AccountMask,
      } }
      className={ classNames('CCP__CarrierAccountForm__Input', classes.textField) }
      onChange={ e => onChange(e.target.value) }
      value={ newLicenseNumber }
      classes={ { underline: classes.underline } }
    />
    <SovosRaisedButton
      onClick={ onSubmit }
      className="CCP__CarrierAccountForm__Submit"
    >
      <span className={ classes.buttonText }>Submit</span>
    </SovosRaisedButton>
    <XIcon
      className="CCP__CarrierAccountForm__Cancel"
      onClick={ cancel }
    />
  </div>
);

UnstyledCarrierAccountsForm.propTypes = {
  newLicenseNumber: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(UnstyledCarrierAccountsForm);
